<template lang="pug">
ev-autocomplete(
  v-model="inputValue",
  v-bind="$attrs"
  :items="$options.constants.EVENT_DIRECTION_TYPES",
  label="Тип мероприятия",
)
</template>

<script>
import { EVENT_DIRECTION_TYPES } from '@/modules/Events/constants';

export default {
  constants: {
    EVENT_DIRECTION_TYPES,
  },
  props: {
    value: {
      type: [Number, Object],
      default: null,
    },
  },
  computed: {
    inputValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>
